<div class="filter-loading">
  <div class="filter-loading__content" *ngFor="let fakeFilter of [1,2,3,4,5,6]">
    <div class="filter-loading__header">
    </div>
    <div class="filter-loading__body" *ngFor="let fakeFilterItem of [1,2,3,4,5]">
      <div class="filter-loading__checkbox">
      </div>
      <div class="filter-loading__label">
      </div>
    </div>
  </div>
</div>
